// imports
import Component from 'minsky-kit/js/components/Component';
import { createApp } from 'vue';
import Icon from '../components/Icon/Icon.vue';

// private statics
import SearchResults from '../components/SearchResults/SearchResults.vue';

// class definition
export default class SearchResultsApp extends Component {
    // constructor
    constructor (args = {}, objectName = 'SearchResultsApp') {
        // super
        super(args, objectName);

        this.app = createApp(SearchResults);

        if (args.drupal) {
            this.app.config.globalProperties.Drupal = args.drupal;
        }

        this.app.component('Icon', Icon);
        this.app.mount(args.$el);
    }

    // methods
    destroy () {
        // super destroy
        super.destroy();
    }

    clear () {
        this.searchWidget.clear();
    }

    // getters & setters
}

// Utils

// Event handlers
